export default {
  title: 'Situation de votre patrimoine',
  subtitle: {
    figures: 'Vos chiffres clés :',
    levers: 'Leviers d\'actions :'
  }
}
